module.exports = __webpack_public_path__ + "static/img/f_b1.9dcf623.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/f_b1.png
// module id = gHIR
// module chunks = 70